import { render, staticRenderFns } from "./QueueNew.vue?vue&type=template&id=e0663c4c&scoped=true&lang=html&"
import script from "./QueueNew.vue?vue&type=script&lang=js&"
export * from "./QueueNew.vue?vue&type=script&lang=js&"
import style0 from "./QueueNew.vue?vue&type=style&index=0&id=e0663c4c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0663c4c",
  null
  
)

export default component.exports